export function formatProvider(provider?: string, provedorWebviagem?: number | null): string {
  const normalized = String(provider || "").trim().toUpperCase();
  const baseProvider = normalized === "WEBVIAGEM" || normalized === "WEBVIAGEM_API"
    ? "GP-API"
    : normalized;

  if (baseProvider !== "GP-API") {
    return baseProvider;
  }

  const complements: Record<number, string> = {
    1: "RJ",
    2: "LUNA",
    3: "BUSON",
    4: "J3",
    5: "GIPSYY",
    6: "Impetus",
    7: "TI-Sistema",
  };
  const complement = provedorWebviagem == null ? undefined : complements[provedorWebviagem];

  return complement ? `${baseProvider}-${complement}` : baseProvider;
}
